<template>
  <div class="relative flex items-stretch flex-grow px-4 py-2 my-3 focus-within:z-10">
    <div class="absolute inset-y-0 left-0 flex items-center pl-6 pointer-events-none">
      <Search class="z-10 w-5 h-5 text-gray-400" aria-hidden="true" />
    </div>
    <TextInput
      :value="search_term"
      input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
      name="search_term"
      type="text"
      is-box-background="true"
      :validate-on-input="true"
      :icon="true"
      :label="$t('Search Co-Owners')"
      :inline-label="true"
      :placeholder="$t('Search Co-Owners')"
      @keydown.space.stop
      @keyup.space.stop
      @keypress.space.stop
      @update:modelValue="
        (e) => {
          search_term = e
        }
      " />
  </div>
  <div class="flex justify-start w-full py-3 bg-gray-100 border-t-2 border-b text-common-grey">
    <div class="w-24 ml-8" />
    <div class="w-48">
      {{ $t("Name") }}
    </div>
    <div class="w-48">
      {{ $t("Role") }}
    </div>
    <div class="w-48">
      {{ $t("Team") }}
    </div>
  </div>
  <div class="h-56 overflow-auto">
    <div v-for="user in filtered_users" :key="user.id" class="mt-4">
      <div class="flex ml-4 space-x-4">
        <div class="w-24">
          <Switch
            :class="[
              selected_co_owners.includes(user.id) ? 'bg-blue' : 'bg-gray-200 dark:bg-dark-screen-background',
              'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
            ]"
            @update:model-value="
              () => {
                handleSelectOwner(user)
              }
            ">
            <span
              aria-hidden="true"
              :class="[
                selected_co_owners.includes(user.id) && $store.state.portfolio.ui_options?.language == 'ar'
                  ? '-translate-x-5'
                  : selected_co_owners.includes(user.id)
                    ? 'translate-x-5'
                    : 'translate-x-0',
                'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
              ]" />
          </Switch>
        </div>
        <div class="w-48">
          {{ user.full_name }}
        </div>
        <div class="w-48">
          {{ $te(user.role_name) ? $t(user.role_name) : user.role_name }}
        </div>
        <div class="w-48">
          {{ getUserTeam(user) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/shared/TextInput.vue"
import { Search } from "lucide-vue-next"
import { Switch } from "@headlessui/vue"

export default {
  components: { TextInput, Search, Switch },
  props: {
    selectedCoOwners: {
      type: Array,
      default: () => []
    },
    teams: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:selectedCoOwners"],
  data() {
    return { search_term: "", filtered_users: [], selected_co_owners: [] }
  },
  watch: {
    search_term() {
      this.getTeamMembers()
    }
  },

  created() {
    this.selected_co_owners = this.selectedCoOwners
    this.getTeamMembers()
  },

  methods: {
    getUserTeam(user) {
      let user_team = "-"
      this.teams.forEach((t) => {
        if (t.users.includes(user.id)) {
          user_team = t.name
        }
      })
      return user_team
    },
    getTeamMembers() {
      this.filtered_users = this.$store.state.data.users.filter((user) =>
        user.full_name.toLowerCase().includes(this.search_term.toLowerCase())
      )
    },
    handleSelectOwner(user) {
      if (this.selected_co_owners.includes(user.id)) {
        const index = this.selected_co_owners.findIndex((o) => o == user.id)
        this.selected_co_owners.splice(index, 1)
      } else {
        this.selected_co_owners.push(user.id)
      }
      this.$emit("update:selectedCoOwners", this.$utils.clone(this.selected_co_owners))
    }
  }
}
</script>
